import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UserEdit = () => {
  const { id } = useParams(); // 获取用户 ID
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`/yonghu/update/${id}`)
      .then(response => {
        if (response.data.code === 0) {
          setUsername(response.data.data.username);
        }
      })
      .catch(err => console.error('Error fetching user:', err));
  }, [id]);

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`/yonghu/update/${id}`, { username, password });
      if (response.data.code === 0) {
        navigate(`/users/${id}`); // 修改成功后跳转到详情页
      } else {
        setError(response.data.msg || t('userMgmt.submitFailed'));
      }
    } catch (err) {
      console.error('Error updating user:', err);
      setError(t('userMgmt.requestFailed'));
    }
  };

  return (
    <div>
      <h1>{t('userMgmt.editUserInfo')}</h1>
      <form onSubmit={handleEdit}>
        <div>
          <label>{t('userMgmt.username')}:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{t('userMgmt.newPassword')}:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit">{t('userMgmt.save')}</button>
      </form>
    </div>
  );
};

export default UserEdit;
